import React, { Component } from 'react';
import SideMenu from '../admin/SideMenu';
import { appDatabasePrimaryFunctions } from '../../base';
import TopMenu from '../admin/TopBar';
import '../../styles/css/AdminMain.css';
import {findFirstAndLastName, convertTimeStampToHumanReadable} from '../utils/HelpfulFunction';
import DatePicker from '../utils/DatePicker';
import Papa from 'papaparse';
import swal from "sweetalert2";

class AdminHome extends Component {
    constructor(props) {
        super(props);
        const todaysDateObject = new Date();
        todaysDateObject.setDate(todaysDateObject.getDate()-30);
        todaysDateObject.setHours(0,0,0,0); // Sets the time to start of the day (midnight)
        const endDateObject = new Date();
        endDateObject.setHours(23,59,59,999); // Sets the time to end of the day (11:59 pm)
        let scoreboardLink = "";
        const splitHref = window.location.href.split("/");
        splitHref.pop();
        scoreboardLink = splitHref.join("/") + "/scoreboard";
        this.state = {
            games: 0,
            users: 0,
            itemsPerPage: 10,
            itemsToShow: 10,
            uniqueGamesUsers: 0,
            loading: false,
            players: 0,
            gameUsers: 0,
            prizesWon: 0,
            lastGame: {},
            uniqueGameUsers: false,
            gamesToShowList: [],
            searchStart: todaysDateObject,
            scoreboardLink: scoreboardLink,
            searchEnd: endDateObject
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange (evt) {
        const target = evt.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            [target.name]: value
        });
    }

    componentDidMount(){
        this.getGames(this.state.searchStart.getTime(), this.state.searchEnd.getTime());
        this.getUsers(this.state.searchStart.getTime(), this.state.searchEnd.getTime());
    }

    async getGames(start = 0, end){
        const vm = this;
        let queryString = appDatabasePrimaryFunctions.ref('gamesList').orderByChild('timeStamp').startAt(start);
        let currentGame = null;
        let currentGameObject = await appDatabasePrimaryFunctions.ref('currentGame').once('value').then(function(snapshot){
            let gameTemp = snapshot.val();
            if(gameTemp && gameTemp.timeStamp > start){
                return gameTemp;
            } else {
                return null;
            }
        })
        if(end){
            queryString = queryString.endAt(end);
            if(currentGameObject && currentGameObject.timeStamp > end){
                currentGameObject = null;
            }
        }
        currentGame = currentGameObject;
        let currentGamePrizes = 0;
        let currentGameUsers = 0;
        let gamesCount = 0;
        if(currentGame){
            currentGamePrizes = currentGamePrizes + await appDatabasePrimaryFunctions.ref('emailsSent').once('value').then(function(snapshot){
                return snapshot.numChildren()
            })
            // const answersCount = await appDatabasePrimaryFunctions.ref("userAnswers").once('value').then(function(snapshot){
            //     return snapshot.numChildren()
            // })
            gamesCount++;
            currentGame.prizesWon = currentGamePrizes;
            currentGame.users = currentGameUsers;
            currentGame.currentGame = true;
        }
        queryString.once('value', function (snapshot) {
            let prizesCount = currentGamePrizes;
            let gameUsersCount = currentGameUsers;
            let gamesArray = [];
            let index = 0;
            snapshot.forEach(function (data) {
                index++;
                prizesCount += data.val().prizes || 0;
                gameUsersCount += data.val().users || 0;
                if(snapshot.numChildren() - vm.state.itemsPerPage < index){
                    gamesArray.unshift(data.val())
                }
            })
            if(currentGame){
                gamesArray.unshift(currentGame)
            }
            vm.setState({
                loading: false,
                games: gamesCount + snapshot.numChildren(),
                prizesWon: prizesCount,
                gameUsers: gameUsersCount,
                gamesToShowList: gamesArray
            })
        });
    }

    async getUsers(start=0, end, returnUsers=false){
        const vm = this;
        let queryString = appDatabasePrimaryFunctions.ref('users').orderByChild('signUpTime');
        if(start){
            queryString = queryString.startAt(start);
        }
        if(end){
            queryString = queryString.endAt(end);
        }
        if(returnUsers){
            return await queryString.once('value').then(function(snapshot) {
                if(snapshot.exists()){
                    return snapshot;
                }
            })
        } else {
            let optInCounts = 0;
            queryString.once('value', function(snapshot){
                snapshot.forEach(function (data){
                    const user = data.val();
                    if(user.optIn || user.optInTwo || user.optInThree || user.optInFour){
                        optInCounts++;
                    }
                })
                vm.setState({
                    loading: false,
                    users: snapshot.numChildren(),
                    optIns: optInCounts
                })
            });
        }
    }

    async getUserData(onlyOptIns) {
        this.setState({ loading: true });

        // ──────────────────────────────────────────────
        // 1) Normalize your date filters
        // ──────────────────────────────────────────────
        let searchStart = this.state.searchStart || 0;
        let searchEnd   = this.state.searchEnd;

        if (typeof searchStart === 'object') {
            searchStart = searchStart.getTime();
        }
        if (searchEnd && typeof searchEnd === 'object') {
            searchEnd = searchEnd.getTime();
        }

        // ──────────────────────────────────────────────
        // 2) Build metadata header (non-tabular lines)
        // ──────────────────────────────────────────────
        let csvHeader = (process.env.REACT_APP_CLEAN_CLIENT_NAME || process.env.REACT_APP_FIREBASE_PROJECT_ID) + ',Game\n,\n';

        const dateGot = new Date(Date.now() - new Date().getTimezoneOffset() * 60 * 1000)
            .toISOString()
            .split('T')[0];

        csvHeader += `Date Data Downloaded,${dateGot}\n`;
        csvHeader += `From,${searchStart ? convertTimeStampToHumanReadable(searchStart) : ''}\n`;
        csvHeader += `To,${searchEnd   ? convertTimeStampToHumanReadable(searchEnd)   : ''}\n,\n`;

        // ──────────────────────────────────────────────
        // 3) Define your column headers array
        // ──────────────────────────────────────────────
        const isMlbApp  = process.env.REACT_APP_IS_MLB_TEAM === "true";
        const emailText = isMlbApp ? 'Okta' : 'Email';

        const finalHeaders = [
            emailText,
            'First Name', 'Last Name', 'Username',
            'Other First Name', 'Other Last Name',
            'Zip Code', 'Street', 'City', 'State', 'Address',
            'Birthday', 'Phone Number', 'Social Handle',
            'Fan Response Text', 'Fan Response Text 2',
            'Short Text Response 1', 'Short Text Response 2',
            'Custom Dropdown', 'Custom Dropdown 2',
            'Opt-In', 'Opt-In 2', 'Opt-In 3', 'Opt-In 4',
            'YesNoQuestion', 'YesExplanation',
            'YesNoQuestion2', 'YesExplanation2',
            'How They Heard', 'User Image',
            'UTM Campaign', 'UTM Medium', 'UTM Source',
            'SRC Code', 'Signed Up'
        ];

        // ──────────────────────────────────────────────
        // 4) Fetch & shape your user rows
        // ──────────────────────────────────────────────
        const timeFrameUsers = await this.getUsers(searchStart, searchEnd, true);
        const dataForCsv = [];

        timeFrameUsers.forEach(snapshot => {
            const user = snapshot.val();

            // If onlyOptIns, skip those with no opt-ins
            if (
                onlyOptIns &&
                !user.optIn && !user.optInTwo &&
                !user.optInThree && !user.optInFour
            ) {
                return;
            }

            const [firstName, lastName]       = findFirstAndLastName(user.name);
            const [otherFirst, otherLast]     = findFirstAndLastName(user.otherName);
            const signedUp                   = user.signUpTime
                ? convertTimeStampToHumanReadable(user.signUpTime)
                : '';

            dataForCsv.push([
                user.email || user.uid || '',
                firstName     || '',
                lastName      || '',
                user.username || '',
                otherFirst    || '',
                otherLast     || '',
                user.zipCode  || '',
                user.street   || '',
                user.city     || '',
                user.state    || '',
                user.address  || '',
                user.birthday || '',
                user.phoneNumber    || '',
                user.socialHandle   || '',
                user.fanResponseToCollectTextInput  || '',
                user.fanResponseToCollectTextInput2 || '',
                user.textInputOne   || '',
                user.textInputTwo   || '',
                user.customDropdownInput  || '',
                user.customDropdownInput2 || '',
                user.optIn       || '',
                user.optInTwo    || '',
                user.optInThree  || '',
                user.optInFour   || '',
                user.yesNoQuestions   || '',
                user.yesExplanation   || '',
                user.yesNoQuestions2  || '',
                user.yesExplanation2  || '',
                user.howYouHeard      || '',
                user.userImage        || '',
                user.utmCampaign      || '',
                user.utmMedium        || '',
                user.utmSource        || '',
                user.srcCode          || '',
                signedUp
            ]);
        });

        // ──────────────────────────────────────────────
        // 5) Strip out any column that’s 100% empty
        // ──────────────────────────────────────────────
        const keepColumn = finalHeaders.map((_, idx) =>
            dataForCsv.some(row => row[idx] !== '' && row[idx] != null)
        );

        const filteredHeaders = finalHeaders.filter((_, idx) => keepColumn[idx]);
        const filteredData    = dataForCsv.map(row =>
            row.filter((_, idx) => keepColumn[idx])
        );

        // ──────────────────────────────────────────────
        // 6) Generate CSV & trigger download
        // ──────────────────────────────────────────────
        const headerLine = Papa.unparse([filteredHeaders], {
            header: false,
            quotes: true
        });
        const csvBody = Papa.unparse(filteredData, {
            header: false,
            quotes: true
        });
        const finalCsv = csvHeader + headerLine + '\n' + csvBody;

        const blob = new Blob([finalCsv], { type: 'text/csv;charset=utf-8;' });
        const url  = URL.createObjectURL(blob);
        const a    = document.createElement('a');
        a.href     = url;

        // build a clean filename
        let cleanString =
            (searchStart ? '_' + convertTimeStampToHumanReadable(searchStart) : '') +
            (searchEnd   ? '_' + convertTimeStampToHumanReadable(searchEnd)   : '');
        cleanString = 'accounts_made' +
            cleanString.replace(/[|&;$%@"<>()+,]/g, '').
            toLowerCase() +
            '.csv';

        a.download = cleanString;
        a.target   = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        this.setState({ loading: false });
    }

    safeTime(timestamp) {
        return timestamp ? convertTimeStampToHumanReadable(timestamp) : '';
    }

    async downloadIntenseGameData(game) {
        this.setState({ loading: true });

        // -------------------------------
        // 1) Build the "metadata" string
        // -------------------------------
        let csvHeader = (process.env.REACT_APP_CLEAN_CLIENT_NAME ||
            process.env.REACT_APP_FIREBASE_PROJECT_ID) + ',Game\n""\n';

        // The date in YYYY-MM-DD format (local time)
        let date_downloaded = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60 * 1000
        )
            .toISOString()
            .split('T')[0];

        const gameAnswers = await appDatabasePrimaryFunctions
            .ref(`userAnswersHistory/${game.id}`)
            .once('value')
            .then(snap => snap.exists() ? snap.val() : []);

        // Count how many have 'rewardSent'
        let totalPrizes = 0;
        for (const userIndex in gameAnswers) {
            if (gameAnswers[userIndex].rewardSent) totalPrizes++;
        }

        csvHeader += `Date Data Downloaded,${date_downloaded}\n`;
        csvHeader += `Game Name,${game.gameName}\n`;
        csvHeader += `Start Time,${game.scheduleInfo ? this.safeTime(game.scheduleInfo.performAt) : ''}\n`;
        csvHeader += `End Time,${game.scheduleInfo ? this.safeTime(game.scheduleInfo.endAt) : ''}\n`;
        csvHeader += `Prizes Won,${totalPrizes}\n""\n`;

        const isMlbApp = process.env.REACT_APP_IS_MLB_TEAM === "true";

        // -------------------------
        // 2) Define the base columns
        // -------------------------
        let baseHeaders = [
            isMlbApp ? 'Okta' : 'Email',
            'First Name', 'Last Name', 'Username',
            'Other First Name', 'Other Last Name',
            'Zip Code', 'Street', 'City', 'State', 'Address',
            'Birthday', 'Phone Number', 'Social Handle',
            'Fan Response Text', 'Fan Response Text 2',
            'Short Text Response 1', 'Short Text Response 2',
            'Custom Dropdown', 'Custom Dropdown 2',
            'Opt-In', 'Opt-In 2', 'Opt-In 3', 'Opt-In 4',
            'YesNoQuestion', 'YesExplanation',
            'YesNoQuestion2', 'YesExplanation2',
            'How They Heard', 'User Image',
            'UTM Campaign', 'UTM Medium', 'UTM Source',
            'SRC Code', 'Number Correct', 'Reward',
            'Code', 'Play Time', 'Redeemed'
        ];

        // dynamic form questions
        let formQuestionHeaders = [], formQuestionIds = [];
        if (this.state.formQuestions) {
            for (const fq of this.state.formQuestions) {
                formQuestionHeaders.push(fq.text || '');
                formQuestionIds.push(fq.id);
            }
        }

        // optional "Other"
        let hasOther = !!(this.state.tenantVariables && this.state.tenantVariables.otherResponse);

        // finalHeaders = base + dynamic + optional Other
        let finalHeaders = [...baseHeaders, ...formQuestionHeaders];
        if (hasOther) finalHeaders.push('Other');

        // ----------------------------
        // 3) Gather all row data
        // ----------------------------
        const usersData = await appDatabasePrimaryFunctions
            .ref('users')
            .once('value')
            .then(snap => snap.val());

        let dataForCsv = [];
        for (const userIndex in gameAnswers) {
            const userInfo = gameAnswers[userIndex];
            const moreUserData = usersData[userInfo.uid] || {};

            const nameResponse = findFirstAndLastName(moreUserData.name);
            const otherNameResponse = findFirstAndLastName(moreUserData.otherName);

            let row = [
                moreUserData.email || moreUserData.uid || '',
                nameResponse[0] || '',
                nameResponse[1] || '',
                moreUserData.username || '',
                otherNameResponse[0] || '',
                otherNameResponse[1] || '',
                moreUserData.zipCode || '',
                moreUserData.street || '',
                moreUserData.city || '',
                moreUserData.state || '',
                moreUserData.address || '',
                moreUserData.birthday || '',
                moreUserData.phoneNumber || '',
                moreUserData.socialHandle || '',
                moreUserData.fanResponseToCollectTextInput || '',
                moreUserData.fanResponseToCollectTextInput2 || '',
                moreUserData.textInputOne || '',
                moreUserData.textInputTwo || '',
                moreUserData.customDropdownInput || '',
                moreUserData.customDropdownInput2 || '',
                moreUserData.optIn || '',
                moreUserData.optInTwo || '',
                moreUserData.optInThree || '',
                moreUserData.optInFour || '',
                moreUserData.yesNoQuestions || '',
                moreUserData.yesExplanation || '',
                moreUserData.yesNoQuestions2 || '',
                moreUserData.yesExplanation2 || '',
                moreUserData.howYouHeard || '',
                moreUserData.userImage || '',
                moreUserData.utmCampaign || '',
                moreUserData.utmMedium || '',
                moreUserData.utmSource || '',
                moreUserData.srcCode || '',
                userInfo.correctAnswers || "0",
                userInfo.rewardSent || '',
                userInfo.code || '',
                userInfo.timeStamp ? this.safeTime(userInfo.timeStamp) : '',
                userInfo.isRedeemed ? 'true' : ''
            ];

            // dynamic answers
            for (const qId of formQuestionIds) {
                let val = '';
                if (
                    moreUserData.form_responses &&
                    (moreUserData.form_responses[qId] === true || moreUserData.form_responses[qId] === false)
                ) {
                    val = String(moreUserData.form_responses[qId]);
                } else {
                    val = userInfo[qId] || '';
                }
                row.push(val);
            }

            // optional "Other"
            if (hasOther) row.push(userInfo['other'] || '');

            dataForCsv.push(row);
        }

        // --------------------------------------------------------
        // 4) **STRIP OUT EMPTY COLUMNS**
        // --------------------------------------------------------
        // Which cols have at least one non-empty value?
        const keepColumn = finalHeaders.map((_, c) =>
            dataForCsv.some(row => row[c] !== '' && row[c] != null)
        );

        // filter headers & data rows
        const filteredHeaders = finalHeaders.filter((_, c) => keepColumn[c]);
        const filteredData = dataForCsv.map(row =>
            row.filter((_, c) => keepColumn[c])
        );

        // --------------------------------------------------------
        // 5) Build CSV with Papa Parse
        // --------------------------------------------------------
        const headerLine = Papa.unparse([filteredHeaders], {
            header: false,
            quotes: true
        });
        const csvBody = Papa.unparse(filteredData, {
            header: false,
            quotes: true
        });
        const finalCsv = csvHeader + headerLine + '\n' + csvBody;

        // -------------------------------------------------------
        // 6) Download via Blob
        // -------------------------------------------------------
        const blob = new Blob([finalCsv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const hiddenElement = document.createElement('a');
        hiddenElement.href = url;
        hiddenElement.target = '_blank';
        const cleanString = game.gameName.replace(/[|&;$%@"<>()+,. ]/g, '').toLowerCase();
        hiddenElement.download = 'gamedata_' + cleanString + '.csv';
        document.body.appendChild(hiddenElement);
        hiddenElement.click();
        document.body.removeChild(hiddenElement);

        this.setState({ loading: false });
    }

    async downloadAllGamesData() {
        this.setState({ loading: true });

        // ──────────────────────────────────────────────
        // 1) Normalize date filters to timestamps
        // ──────────────────────────────────────────────
        let { searchStart, searchEnd } = this.state;
        let start = searchStart || 0;
        let end   = searchEnd   || Date.now();

        if (typeof start === 'object') start = start.getTime();
        if (typeof end   === 'object') end   = end.getTime();

        const BATCH_SIZE = 10;

        // ──────────────────────────────────────────────
        // 2) Load games and users from Firebase
        // ──────────────────────────────────────────────
        let gamesQuery = appDatabasePrimaryFunctions
            .ref('gamesList')
            .orderByChild('timeStamp')
            .startAt(start);
        if (end) gamesQuery = gamesQuery.endAt(end);

        const currentGameQuery = appDatabasePrimaryFunctions.ref('currentGame');

        const [usersSnap, gamesSnap, currentGameSnap] = await Promise.all([
            appDatabasePrimaryFunctions.ref('users').once('value'),
            gamesQuery.once('value'),
            currentGameQuery.once('value'),
        ]);

        const usersData = usersSnap.val() || {};

        // Build flat list of game IDs + lookup
        const gameIdList = [];
        const gameList   = {};
        gamesSnap.forEach(s => {
            const g = s.val();
            gameIdList.push(g.id);
            gameList[g.id] = g;
        });
        const curr = currentGameSnap.val();
        if (curr && curr.timeStamp >= start && curr.timeStamp <= end) {
            gameIdList.push(curr.id);
            gameList[curr.id] = curr;
        }

        // ──────────────────────────────────────────────
        // 3) Initialize CSV rows array (with header row)
        // ──────────────────────────────────────────────
        const isMlbApp = process.env.REACT_APP_IS_MLB_TEAM === "true";
        const rows = [
            [isMlbApp ? "Okta" : 'Game User Email', 'Game Name', 'Won', 'Reward Name', 'Redeemed']
        ];

        // ──────────────────────────────────────────────
        // 4) Batch‐process each game's answers
        // ──────────────────────────────────────────────
        const processBatch = async batch => {
            const snaps = await Promise.all(
                batch.map(id =>
                    appDatabasePrimaryFunctions
                        .ref('userAnswersHistory').child(id)
                        .orderByChild('timeStamp')
                        .once('value')
                )
            );

            snaps.forEach((snap, idx) => {
                const gameId   = batch[idx];
                const gameName = gameList[gameId].gameName;

                snap.forEach(child => {
                    const u        = child.val();
                    const info     = usersData[u.uid] || {};
                    const prizeWon = u.pickCorrect ? 'Won' : 'Lost';
                    const redeemed = u.isRedeemed   ? 'Yes' : '';

                    rows.push([
                        info.email || info.uid || '',
                        gameName,
                        prizeWon,
                        u.rewardSent || '',
                        redeemed
                    ]);
                });
            });
        };

        for (let i = 0; i < gameIdList.length; i += BATCH_SIZE) {
            await processBatch(gameIdList.slice(i, i + BATCH_SIZE));
        }

        // ──────────────────────────────────────────────
        // 5) Remove columns that are empty in all data rows
        // ──────────────────────────────────────────────
        const dataRows = rows.slice(1);
        const keepColumn = rows[0].map((_, colIdx) =>
            dataRows.some(row => row[colIdx] !== '' && row[colIdx] != null)
        );

        const filteredRows = rows.map(row =>
            row.filter((_, colIdx) => keepColumn[colIdx])
        );

        // ──────────────────────────────────────────────
        // 6) Convert to CSV with Papa Parse
        // ──────────────────────────────────────────────
        const csvContent = Papa.unparse(filteredRows, {
            header: false,
            quotes: true
        });

        // ──────────────────────────────────────────────
        // 7) Trigger download via Blob
        // ──────────────────────────────────────────────
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url  = URL.createObjectURL(blob);
        const a    = document.createElement('a');
        a.href     = url;
        a.download = `games_data_${start ? convertTimeStampToHumanReadable(start) : ''}_to_${convertTimeStampToHumanReadable(end)}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        this.setState({ loading: false });
    }

    searchData(){
        let searchStart = this.state.searchStart;
        let searchEnd = this.state.searchEnd;
        if(searchStart){
            searchStart = searchStart.getTime();
        }
        if(searchEnd){
            searchEnd = searchEnd.getTime();
        }
        this.setState({
            loading: true,
            itemsPerPage: this.state.itemsPerPage
        }, ()=>{

        })
        this.getGames(searchStart,searchEnd)
        this.getUsers(searchStart,searchEnd)
    }

    onNextPage() {
        const vm = this;
        const newAmountToShow = this.state.itemsToShow + this.state.itemsPerPage;
        let searchStart = this.state.searchStart;
        let searchEnd = this.state.searchEnd;
        if(searchStart){
            searchStart = searchStart.getTime();
        }
        if(searchEnd){
            searchEnd = searchEnd.getTime();
        }
        let queryString = appDatabasePrimaryFunctions.ref('gamesList').orderByChild('timeStamp').limitToLast(newAmountToShow).startAt(searchStart);
        if (searchEnd) {
            queryString = queryString.endAt(searchEnd)
        }
        queryString.once('value', function (snapshot) {
            let gamesArray = [];
            snapshot.forEach(function (data) {
                gamesArray.unshift(data.val())
            })
            vm.setState({
                itemsToShow: newAmountToShow,
                gamesToShowList: gamesArray
            });
        })
    }

    async deleteGame(gameToDelete) {
        if (!gameToDelete || !gameToDelete.id) {
            swal('Error!', 'No game ID provided.', 'error');
            return;
        }

        const responseFromPopUp = await swal({
            title: 'WARNING!',
            text: 'This will delete ALL data associated with the game. Are you sure you want to do this?',
            type: 'warning',
            input: 'text',
            inputPlaceholder: 'Type DELETE to confirm',
            showCancelButton: true,
            confirmButtonText: 'Submit',
            preConfirm: (inputValue) => {
                if (inputValue !== 'DELETE') {
                    swal.showValidationMessage('You need to type DELETE to confirm');
                    return false;
                }
            }
        });

        if (!responseFromPopUp || !responseFromPopUp.value) return;

        this.setState({ loading: true });

        const removeNodesByGameId = async (refPath, gameIdField, isNested = false) => {
            const ref = appDatabasePrimaryFunctions.ref(refPath).orderByChild(gameIdField).equalTo(gameToDelete.id);
            const snapshot = await ref.once('value');

            if (snapshot.exists()) {
                const nodes = snapshot.val();
                const chunkSize = 50; // Define a reasonable chunk size
                let currentChunk = {};

                for (const key in nodes) {
                    if (isNested) {
                        for (const nestedKey in nodes[key]) {
                            currentChunk[`${refPath}/${key}/${nestedKey}`] = null;
                            if (Object.keys(currentChunk).length >= chunkSize) {
                                await appDatabasePrimaryFunctions.ref().update(currentChunk);
                                currentChunk = {};
                            }
                        }
                    } else {
                        if(refPath === 'userGameHistory'){
                            currentChunk[`${refPath}/${key}/${gameIdField}`] = null;
                        } else {
                            currentChunk[`${refPath}/${key}`] = null;
                        }
                        if (Object.keys(currentChunk).length >= chunkSize) {
                            await appDatabasePrimaryFunctions.ref().update(currentChunk);
                            currentChunk = {};
                        }
                    }
                }

                if (Object.keys(currentChunk).length > 0) {
                    await appDatabasePrimaryFunctions.ref().update(currentChunk);
                }
            }
        };

        try {
            // Step 1: Attempt to remove userAnswersHistory
            try {
                const userAnswersHistoryRef = appDatabasePrimaryFunctions.ref(`userAnswersHistory/${gameToDelete.id}`);
                await userAnswersHistoryRef.remove();
            } catch (error) {
                // If removal fails, chunk the deletions
                await removeNodesByGameId(`userAnswersHistory/${gameToDelete.id}`, 'gameId', true);
            }

            // Step 2: Find and remove the game
            const gameRef = appDatabasePrimaryFunctions.ref('gamesList').orderByChild('id').equalTo(gameToDelete.id);
            const snapshot = await gameRef.once('value');

            if (snapshot.exists()) {
                const gameKey = Object.keys(snapshot.val())[0];
                await appDatabasePrimaryFunctions.ref(`gamesList/${gameKey}`).remove();

                // Step 3: Remove gameId from userGameHistory
                await removeNodesByGameId('userGameHistory', gameToDelete.id);

                // Step 4: Remove entries in redeemedPrize with the same gameId
                await removeNodesByGameId('redeemedPrize', 'gameId');

                this.setState({
                    gamesToShowList: this.state.gamesToShowList.filter(game => game.id !== gameToDelete.id)
                });

                swal('Deleted!', 'The game has been deleted.', 'success');
            } else {
                swal('Error!', 'Game not found.', 'error');
            }
        } catch (error) {
            swal('Error!', 'An error occurred while deleting the game.', 'error');
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const totalUsers = this.state.users || 0;
        const optIns = this.state.optIns || 0;
        const gameUsers = this.state.gameUsers || 0;
        const prizesWon = this.state.prizesWon || 0;
        const fan_side_link = process.env.REACT_APP_FAN_LINK || "";
        const leaderboardLink = fan_side_link ? fan_side_link.replace(/\/+$/, "") + "/leaderboard" : "";
        const scoreboardOnly = this.props.scoreboardOnly || false;
        const isSqwadEmployee = this.props.isSqwadEmployee || false;

        return (
          <div className="admin-wrapper">
            <div className="loading-screen" style={{display: this.state.loading ? 'block' : 'none' }}/>
            <SideMenu/>
            <TopMenu/>
            <div className="admin-main-panel">
                <div className="row" style={{width:'100%'}}>
                    <div className="col-md-11">
                        <p className="admin-header-text" style={{marginTop:'10px'}}>Game link: <span style={{fontSize:'20px'}}>{fan_side_link}</span>
                            <br/>
                            Scoreboard link: <span style={{fontSize:'20px'}}>{this.state.scoreboardLink}</span>
                            <br/>
                            Leaderboard link: <span style={{fontSize:'20px'}}>{leaderboardLink}</span>
                        </p>
                    </div>
                    <div className="col-md-1">
                        <p style={{color: "black"}}>
                            v{process.env.REACT_APP_VERSION}
                        </p>
                    </div>
                </div>
                <form className="form-horizontal" style={{marginLeft: 20, marginBottom:10}}>
                    <div className="row g-3 align-items-center">
                        <div className="col-auto">
                            <DatePicker
                                isClearable
                                selected={this.state.searchStart}
                                onChange={date => {
                                    if(date) date.setHours(0,0,0,0);
                                    this.setState({searchStart: date});
                                }}
                            />
                        </div>

                        <div className="col-auto">
                            <DatePicker
                                isClearable
                                selected={this.state.searchEnd}
                                onChange={date => {
                                    if(date) date.setHours(23,59,59,999);
                                    this.setState({searchEnd: date});
                                }}
                            />
                        </div>
                        <div className="col-auto">
                            <button className="btn btn-primary btn-admin" type="button" onClick={()=>this.searchData()}>Search</button>
                        </div>
                        {!scoreboardOnly && isSqwadEmployee &&
                            <div className="col-auto">
                                <button className="btn btn-primary btn-admin" type="button" onClick={()=>this.downloadAllGamesData()}>Download All Games</button>
                            </div>
                        }
                    </div>
                </form>
                <div className="admin-grid-container four-columns">
                    <div className="card card-styles text-xs-center" style={{backgroundColor:"black"}}>
                        <div className="card-body">
                            <blockquote className="card-bodyquote" style={{margin:0}}>
                                <div className="row">
                                    <div className="col-md-8">
                                        <p style={{color:"white", fontSize:50, margin:0}}>{totalUsers}</p>
                                        <span style={{color:"#f8f8ff", fontSize:20}}>Accounts Created</span>
                                    </div>
                                    {isSqwadEmployee &&
                                        <div className="col-md-4" style={{fontSize: 40, alignSelf: "center"}}>
                                            <i className="fa fa-arrow-circle-o-down" aria-hidden="true" style={{color: "white", cursor: "pointer"}} onClick={() => this.getUserData()}/>
                                        </div>
                                    }
                                </div>
                            </blockquote>
                        </div>
                    </div>
                    <div className="card card-styles text-xs-center" style={{backgroundColor:"black"}}>
                        <div className="card-body">
                            <blockquote className="card-bodyquote" style={{margin:0}}>
                                <div className="row">
                                    <div className="col-md-8">
                                        <p style={{color:"white", fontSize:50, margin:0}}>{optIns}</p>
                                        <span style={{color:"#f8f8ff", fontSize:20}}>Opt Ins</span>
                                    </div>
                                    {(optIns > 0 && !scoreboardOnly) &&
                                        <div className="col-md-4" style={{fontSize: 40, alignSelf: "center"}}>
                                            <i className="fa fa-arrow-circle-down" aria-hidden="true" style={{color: "white", cursor: "pointer"}} onClick={() => this.getUserData(true)}/>
                                        </div>
                                    }
                                </div>
                            </blockquote>
                        </div>
                    </div>
                    <div className="card card-styles text-xs-center" style={{backgroundColor:"black"}}>
                        <div className="card-body">
                            <blockquote className="card-bodyquote" style={{margin:0}}>
                                <div className="row">
                                    <div className="col-md-8">
                                        <p style={{color:"white", fontSize:50, margin:0}}>{gameUsers}</p>
                                        <span style={{color:"#f8f8ff", fontSize:20}}>Game Users</span>
                                    </div>
                                </div>
                            </blockquote>
                        </div>
                    </div>
                    <div className="card card-styles text-xs-center" style={{backgroundColor:"black"}}>
                        <div className="card-body">
                            <blockquote className="card-bodyquote" style={{margin:0}}>
                                <div className="row">
                                    <div className="col-md-8">
                                        <p style={{color:"white", fontSize:50, margin:0}}>{prizesWon}</p>
                                        <span style={{color:"#f8f8ff", fontSize:20}}>Prizes Won</span>
                                    </div>
                                </div>
                            </blockquote>
                        </div>
                    </div>
                </div>
                <div style={{margin:20}}>
                    {this.state.gamesToShowList && this.state.gamesToShowList.length > 0 &&
                    <>
                        {
                            this.state.gamesToShowList.map(function (item, index) {
                                console.log(item)
                                return (
                                    <div key={index} className="card card-styles text-xs-center"
                                         style={{marginBottom: 10}}>
                                        <div className="card-body"
                                             style={{boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 8px 0px"}}>
                                            <div className="row" style={{alignItems: 'center'}}>
                                                <div className="col-md-2">
                                                    <span style={{color: 'black', fontSize: 14}}>{convertTimeStampToHumanReadable(item.timeStamp)}</span>
                                                </div>
                                                <div className="col-md-3" style={{fontSize: 30}}>
                                                    {item.gameName}
                                                </div>
                                                <div className="col-md-3" style={{textAlign: 'right'}}>
                                                    <span style={{fontSize: 25}}>{item.users || item.gameUsers || 0}</span>
                                                    <span style={{color: 'black', fontSize: 15, marginRight: 15}}>Played</span>
                                                    <span style={{fontSize: 25}}>{item.prizes || item.prizesWon || 0}</span>
                                                    <span style={{color: 'black', fontSize: 15}}>Prizes Won</span>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="row" style={{fontSize: 20, justifyContent: 'flex-end'}}>
                                                        {item.prizesWon !== null && !item.currentGame &&
                                                            <div className="col-auto">
                                                                <button onClick={() => this.downloadIntenseGameData(item)} className="export-button-styles btn btn-primary btn-lg download-button mobile-hide">
                                                                    <span className="fa fa-arrow-circle-down"/> Download Game Data
                                                                </button>
                                                            </div>
                                                        }
                                                        {item.currentGame &&
                                                            <div className="col-auto">
                                                                <button onClick={() => window.location.href='/setupgame'} className="export-button-styles btn btn-primary btn-lg download-button mobile-hide">
                                                                    Go To Current Game
                                                                </button>
                                                            </div>
                                                        }
                                                        {!item.currentGame &&
                                                            <div className="col-auto">
                                                                <button onClick={() => this.deleteGame(item)} className="btn btn-danger btn-lg">
                                                                    Delete
                                                                </button>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }, this)
                        }
                        {this.state.games > this.state.gamesToShowList.length &&
                        <button className="btn btn-primary" onClick={()=>this.onNextPage()}>
                            More
                        </button>
                        }
                    </>
                    }
                </div>
            </div>
         </div>
        );
    }
}

export default AdminHome
